<template>
  <div>
    <Form :model="form" ref="Form" :rules="rules">
      <FormItem prop="passwd">
        <Input type="password" v-model="form.passwd" placeholder="请输入新密码"></Input>
      </FormItem>
      <FormItem prop="passwdCheck">
        <Input type="password" v-model="form.passwdCheck" placeholder="请确认原密码"></Input>
      </FormItem>
    </Form>
  </div>
</template>

<script>

export default {
  data () {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.form.passwd) {
        callback(new Error('与新密码不匹配'))
      } else {
        callback()
      }
    }
    return {
      form: {
        passwd: '',
        passwdCheck: ''
      },
      rules: {
        passwd: [{ required: true, message: '请输入6-12位长度的新密码' }],
        passwdCheck: [{ validator: validatePassCheck, trigger: 'blur' }]
      }
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.Form.validate((valid) => {
          if (valid) {
            return resolve(this.form.passwd)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
